import { css } from 'styled-components';
import {
  getTypography, getSpacing, SpacingName, TypographyName, BreakpointQueryName, ThemedFunctor, rgba,
} from '@doveit/lego';

export const list: ThemedFunctor = ({
  theme,
  $inline,
}) => css`
  display: flex;
  position: relative;
  overflow: hidden;
  flex-wrap: ${$inline ? 'nowrap' : 'wrap'};

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 2rem;
    background-image: linear-gradient(to right, ${rgba(theme.palettes.neutrals.lightest, 0)} , ${theme.palettes.neutrals.lightest});
  }

  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    &::after {
      display: none;
    }
  }
`;

export const item: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALLER)}
  display: inline-flex;
  align-items: center;
  ${getSpacing.marginRight(theme, SpacingName.SMALLEST)};

  &:last-child {
    margin-right: 0;
  }

  > a {
    color: ${theme.palettes.brand.primary};
    text-decoration: underline;
  }

  > a, span {
    white-space: nowrap;
  }
`;

export const symbolContainer: ThemedFunctor = ({
  theme,
}) => css`
  display: flex;
  ${getSpacing.marginRight(theme, SpacingName.SMALLEST)};
`;
